module.exports = "/images/shield.svg?b7279820527cb83000f176413913f2f5";